/* terranova · portada (templates/index.json)
   Despegue del hero, viaje por continentes (scroll horizontal), ruta punteada con el isotipo,
   vista previa de las tres líneas, acentos por sección y animación de carga.
   Se apoya en window.TN (assets/theme.js): nav, menú, revelados y contadores ya los hace theme.js.
   Compatible con el editor de temas: shopify:section:load / unload / reorder y block:select. */
(function () {
  'use strict';
  var TN = window.TN;
  if (!TN || TN.homeReady) return;
  TN.homeReady = true;
  TN.homeScroll = true; /* este archivo llama a TN.navState() desde su propio bucle de scroll */

  var doc = document;
  var root = doc.documentElement;
  var reduced = TN.reduced;
  var clamp01 = TN.clamp01;
  var lerp = TN.lerp;
  /* curva del estático (cuadrática); TN.easeIO es cúbica */
  function easeIO(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
  function $(id) { return doc.getElementById(id); }
  function toArr(list) { return Array.prototype.slice.call(list || []); }
  var hoverMQ = window.matchMedia('(hover:hover)');

  var DART = '<svg viewBox="0 0 391 341" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(4.16667,0,0,4.16667,195.157,287.364)"><path d="M0,-56.201L43.945,-68.871C46.206,-69.523 47.83,-66.71 46.135,-65.077L13.19,-33.355L2.19,11.037C1.624,13.322 -1.624,13.322 -2.19,11.037L-13.19,-33.355L-46.135,-65.077C-47.83,-66.71 -46.206,-69.523 -43.945,-68.871L0,-56.201Z" fill="currentColor"/></g></svg>';

  /* ---------------- referencias (se renuevan tras cada recarga de sección) ---------------- */
  var S = { heroTop: 0, tripStart: 0, tripH: 1, tripMax: 0 };
  var heroParked = false, tripParked = true;
  function refs() {
    S.nav = $('nav');
    S.heroSec = $('hero');
    S.heroPin = $('heroPin');
    S.heroImg = $('heroImg');
    S.heroPhoto = $('heroPhoto');
    S.heroType = $('heroType');
    var track = $('tripTrack');
    if (track !== S.tripTrack) tripParked = false;
    S.tripSec = $('trip');
    S.tripTrack = track;
    S.tripNow = $('tripNow');
    S.tpImgs = track ? toArr(track.querySelectorAll('.tp img')) : [];
    S.tripPanels = track ? track.querySelectorAll('.tp').length : 0;
    S.preview = $('preview');
    S.pImgs = S.preview ? toArr(S.preview.querySelectorAll('img')) : [];
    heroParked = false;
  }
  function docTop(el) { return el.getBoundingClientRect().top + window.scrollY; }
  function measure() {
    S.heroTop = S.heroSec ? docTop(S.heroSec) : 0;
    if (S.tripSec && S.tripTrack) {
      S.tripStart = docTop(S.tripSec);
      S.tripH = Math.max(1, S.tripSec.offsetHeight - window.innerHeight);
      S.tripMax = S.tripTrack.scrollWidth - window.innerWidth;
    }
  }

  /* ---------------- animación de carga ---------------- */
  function initLoader() {
    var loader = $('loader');
    if (!loader || loader.getAttribute('data-bound')) return;
    loader.setAttribute('data-bound', '');
    var finished = false;
    function done() {
      if (finished) return;
      finished = true;
      loader.classList.add('done');
      setTimeout(function () { if (loader.parentNode) loader.parentNode.removeChild(loader); }, 950);
    }
    function onLoad() { setTimeout(done, reduced ? 0 : 1350); }
    if (doc.readyState === 'complete') onLoad(); else window.addEventListener('load', onLoad);
    setTimeout(done, 3200);
  }

  /* ---------------- foto del hero al azar ---------------- */
  /* El script en línea de la sección la elige antes del primer pintado; esto cubre las
     recargas del editor (los <script> de una sección re-renderizada no se ejecutan). */
  function heroPick(tpl) {
    var wrap = $('heroImg');
    if (!wrap) return;
    var cur = $('heroPhoto');
    if (cur && !tpl) return;
    if (!tpl) {
      var list = wrap.querySelectorAll('template[data-hero-pic]');
      if (!list.length) return;
      tpl = list[Math.floor(Math.random() * list.length)];
    }
    var src = tpl.content && tpl.content.querySelector('img');
    if (!src) return;
    var img = src.cloneNode(true);
    img.id = 'heroPhoto';
    var pos = tpl.getAttribute('data-pos');
    if (pos) img.style.objectPosition = pos;
    if (cur) {
      img.style.transform = cur.style.transform;
      cur.parentNode.replaceChild(img, cur);
    } else {
      wrap.insertBefore(img, wrap.firstChild);
    }
    S.heroPhoto = img;
  }

  /* ---------------- acento por sección ---------------- */
  var accIO = null;
  function setAccent(sec) {
    root.style.setProperty('--accent', 'var(--' + (sec.getAttribute('data-accent') || 'cyan') + ')');
    root.style.setProperty('--routec', sec.getAttribute('data-routec') || 'var(--cyan-lt)');
    var key = sec.getAttribute('data-nav');
    toArr(doc.querySelectorAll('.nav-links .nl>a')).forEach(function (a) {
      a.classList.toggle('active', !!key && (a.pathname || '').indexOf('/' + key) > -1);
    });
  }
  function homeSections(scope) {
    var out = toArr(scope.querySelectorAll ? scope.querySelectorAll('section.home-sec') : []);
    if (scope.matches && scope.matches('section.home-sec')) out.unshift(scope);
    return out;
  }
  function accentInit(scope) {
    if (!('IntersectionObserver' in window)) return;
    if (!accIO) {
      accIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) setAccent(e.target); });
      }, { rootMargin: '-40% 0px -55% 0px' });
    }
    homeSections(scope).forEach(function (s) {
      if (s.__tnAcc) return;
      s.__tnAcc = true;
      accIO.observe(s);
    });
  }

  /* ---------------- HERO: despegue ---------------- */
  function hero() {
    if (reduced || !S.heroSec || !S.heroImg || !S.heroPin) return;
    var ih = window.innerHeight;
    var h = Math.max(1, S.heroSec.offsetHeight - ih);
    var y = window.scrollY - S.heroTop;
    if (y > h + ih) { if (!heroParked) heroParked = true; else return; } else heroParked = false;
    var p = clamp01(y / h);
    var a = easeIO(clamp01(p / 0.62));          /* la ventana se abre */
    var ty = clamp01((p - 0.42) / 0.3);         /* el texto sale */
    var mob = window.innerWidth <= 700;
    var t0 = mob ? 10 : 23, r0 = mob ? 22 : 14, b0 = mob ? 48 : 11, l0 = mob ? 22 : 57, rr0 = mob ? 110 : 190;
    S.heroImg.style.clipPath = 'inset(' + lerp(t0, 0, a) + '% ' + lerp(r0, 0, a) + '% ' + lerp(b0, 0, a) + '% ' + lerp(l0, 0, a) + '% round ' + lerp(rr0, 0, a) + 'px)';
    if (S.heroPhoto) S.heroPhoto.style.transform = 'scale(' + lerp(1.6, 1.03, a) + ') translate(' + lerp(16, 0, a) + '%,' + lerp(3, 0, a) + '%)';
    if (S.nav) S.nav.classList.toggle('logosm', p > 0.42);
    if (S.heroType) {
      S.heroType.style.opacity = 1 - ty;
      S.heroType.style.transform = 'translateY(' + (-60 * ty) + 'px)';
    }
    S.heroPin.classList.toggle('flown', p > 0.78);
    S.heroPin.classList.toggle('flying', p > 0.04);
  }
  function logoState() {
    /* sin hero (sección quitada) el logo se reduce como en el resto del sitio */
    if (!S.heroSec && S.nav) S.nav.classList.toggle('logosm', window.scrollY > 40);
  }

  /* ---------------- viaje por continentes (horizontal) ---------------- */
  function trip() {
    var tr = S.tripTrack;
    if (!tr || !S.tripSec) return;
    if (reduced || window.innerWidth <= 900) {
      if (tr.style.transform) { tr.style.transform = ''; S.tpImgs.forEach(function (im) { im.style.transform = ''; }); }
      tripParked = false;
      return;
    }
    var y = window.scrollY, ih = window.innerHeight;
    if (y < S.tripStart - ih || y > S.tripStart + S.tripH + ih) {
      if (!tripParked) {
        tripParked = true;
        tr.style.transform = 'translate3d(' + (-S.tripMax * (y < S.tripStart ? 0 : 1)) + 'px,0,0)';
      }
      return;
    }
    tripParked = false;
    var p = clamp01((y - S.tripStart) / S.tripH);
    tr.style.transform = 'translate3d(' + (-S.tripMax * p) + 'px,0,0)';
    var shift = (p * 60 - 30) * -0.4;
    for (var i = 0; i < S.tpImgs.length; i++) S.tpImgs[i].style.transform = 'scale(1.12) translateX(' + shift + 'px)';
    if (S.tripNow && S.tripPanels) {
      var n = Math.min(S.tripPanels, Math.floor(p * S.tripPanels) + 1);
      S.tripNow.textContent = (n < 10 ? '0' : '') + n;
    }
  }
  function scrollToPanel(tp) {
    if (!S.tripTrack || !S.tripSec) return;
    if (reduced || window.innerWidth <= 900) {
      S.tripTrack.scrollTo({ left: Math.max(0, tp.offsetLeft - S.tripTrack.clientWidth * 0.1), behavior: 'smooth' });
      return;
    }
    measure();
    var p = clamp01((tp.offsetLeft - window.innerWidth * 0.3) / Math.max(1, S.tripMax));
    window.scrollTo({ top: S.tripStart + p * S.tripH, behavior: 'instant' });
  }

  /* ---------------- ruta punteada con el isotipo ---------------- */
  var rPath = null, rLen = 0, rStartY = 0, rEndY = 0, rClip = null, rDocH = 0, rLUT = null;
  function mkOverlay(id, html) {
    var el = $(id);
    if (el) return el;
    el = doc.createElement('div');
    el.id = id;
    el.setAttribute('aria-hidden', 'true');
    if (html) el.innerHTML = html;
    doc.body.insertBefore(el, doc.body.firstChild);
    return el;
  }
  function clearRoute() {
    rPath = null; rLUT = null; rClip = null;
    if (S.route) { S.route.innerHTML = ''; S.route.style.height = '0px'; }
    if (S.dart) S.dart.style.display = 'none';
  }
  function buildRoute() {
    var wps = toArr(doc.querySelectorAll('section.home-sec > .wp'));
    if (reduced || window.innerWidth <= 1080 || !wps.length) { clearRoute(); return; }
    S.dart = mkOverlay('rt-dart-fx', DART);
    S.route = mkOverlay('route');
    /* altura a 0 antes de medir: si el documento se acorta (editor), la ruta vieja no lo estira */
    S.route.innerHTML = '';
    S.route.style.height = '0px';
    var iw = window.innerWidth, ih = window.innerHeight, sy = window.scrollY;
    var docH = root.scrollHeight;
    S.route.style.height = docH + 'px';
    var pts = wps.map(function (w) {
      var r = w.parentElement.getBoundingClientRect();
      return { x: iw * (+w.getAttribute('data-x') || 0) / 100, y: r.top + sy + Math.min(180, r.height * 0.18) };
    });
    pts.unshift({ x: iw * 0.5, y: ih * 1.55 });
    /* catmull-rom a bezier */
    var d = 'M ' + pts[0].x + ' ' + pts[0].y;
    for (var i = 0; i < pts.length - 1; i++) {
      var p0 = pts[Math.max(0, i - 1)], p1 = pts[i], p2 = pts[i + 1], p3 = pts[Math.min(pts.length - 1, i + 2)];
      var c1x = p1.x + (p2.x - p0.x) / 6, c1y = p1.y + (p2.y - p0.y) / 6;
      var c2x = p2.x - (p3.x - p1.x) / 6, c2y = p2.y - (p3.y - p1.y) / 6;
      d += ' C ' + c1x + ' ' + c1y + ' ' + c2x + ' ' + c2y + ' ' + p2.x + ' ' + p2.y;
    }
    rStartY = pts[0].y;
    rEndY = pts[pts.length - 1].y;
    rDocH = docH;
    var svg = '<svg width="' + iw + '" height="' + docH + '" viewBox="0 0 ' + iw + ' ' + docH + '" preserveAspectRatio="none">';
    S.route.innerHTML = svg + '<path class="rt-base" d="' + d + '"/></svg><div id="rt-clip">' + svg + '<path class="rt-prog" d="' + d + '"/></svg></div>';
    rPath = S.route.querySelector('.rt-base');
    rLen = rPath.getTotalLength();
    /* Tabla de puntos precalculada: el bucle de scroll nunca llama a getPointAtLength() por cuadro */
    var N = 256;
    rLUT = new Array(N + 1);
    for (var k = 0; k <= N; k++) { var q = rPath.getPointAtLength(rLen * (k / N)); rLUT[k] = { x: q.x, y: q.y }; }
    rClip = $('rt-clip');
    rpSmooth = rpTarget = -1; /* fuerza un cuadro al reconstruir */
  }
  var rpTarget = 0, rpSmooth = 0, rLoopOn = false;
  function routeTick() {
    if (!rPath || reduced || window.innerWidth <= 1080) return;
    var focus = window.scrollY + window.innerHeight * 0.62;
    rpTarget = clamp01((focus - rStartY) / Math.max(1, rEndY - rStartY));
    if (rpSmooth < 0) rpSmooth = rpTarget;
    if (!rLoopOn) { rLoopOn = true; requestAnimationFrame(routeLoop); }
  }
  function luSample(p) {
    var N = rLUT.length - 1, f = clamp01(p) * N, i = Math.floor(f), t = f - i;
    var a = rLUT[i], b = rLUT[Math.min(N, i + 1)];
    return { x: a.x + (b.x - a.x) * t, y: a.y + (b.y - a.y) * t };
  }
  function routeLoop() {
    var settled = Math.abs(rpTarget - rpSmooth) < 0.0004;
    rpSmooth = settled ? rpTarget : rpSmooth + (rpTarget - rpSmooth) * 0.1;
    if (settled) rLoopOn = false; else requestAnimationFrame(routeLoop);
    if (!rPath || !rLUT || !rClip || !S.dart) return;
    var p = rpSmooth;
    var pt = luSample(p);
    var pt2 = luSample(p + 3 / rLen);
    var ang = Math.atan2(pt2.y - pt.y, pt2.x - pt.x) * 180 / Math.PI - 90;
    rClip.style.clipPath = 'inset(0 0 ' + Math.max(0, rDocH - pt.y) + 'px 0)';
    var vy = pt.y - window.scrollY;
    var on = p > 0.001 && p < 0.999 && vy > -60 && vy < window.innerHeight + 60;
    S.dart.style.display = on ? 'block' : 'none';
    if (on) S.dart.style.transform = 'translate3d(' + (pt.x - 10) + 'px,' + (vy - 10) + 'px,0) rotate(' + ang + 'deg)';
  }

  /* ---------------- vista previa al pasar por las tres líneas ---------------- */
  var px = 0, py = 0, tx = 0, tyy = 0, pOn = false, pRAF = null;
  function pLoop() {
    if (!S.preview) { pRAF = null; return; }
    px = lerp(px, tx, 0.14); py = lerp(py, tyy, 0.14);
    S.preview.style.left = (px - 150) + 'px';
    S.preview.style.top = (py - 200) + 'px';
    if (pOn || Math.abs(px - tx) > 0.5) pRAF = requestAnimationFrame(pLoop); else pRAF = null;
  }
  function bindRows(scope) {
    toArr(scope.querySelectorAll ? scope.querySelectorAll('.lrow') : []).forEach(function (row) {
      if (row.__tnRow) return;
      row.__tnRow = true;
      row.addEventListener('mouseenter', function (e) {
        if (!hoverMQ.matches || window.innerWidth <= 1080 || !S.preview) return;
        var cls = 'pv-' + row.getAttribute('data-img'), hit = false;
        S.pImgs.forEach(function (im) { var on = im.classList.contains(cls); im.classList.toggle('show', on); if (on) hit = true; });
        if (!hit) return;
        pOn = true;
        S.preview.classList.add('on');
        tx = e.clientX; tyy = e.clientY;
        if (px === 0) { px = tx; py = tyy; }
        if (!pRAF) pLoop();
      });
      row.addEventListener('mousemove', function (e) { tx = e.clientX; tyy = e.clientY; });
      row.addEventListener('mouseleave', function () { pOn = false; if (S.preview) S.preview.classList.remove('on'); });
    });
  }

  /* ---------------- bucle principal ---------------- */
  var ticking = false;
  function frame() {
    ticking = false;
    TN.navState();
    hero();
    logoState();
    trip();
    routeTick();
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(frame);
  }
  function rebuild() { refs(); measure(); buildRoute(); onScroll(); }
  var rbT = null;
  function scheduleRebuild(delay) {
    clearTimeout(rbT);
    rbT = setTimeout(rebuild, delay == null ? 120 : delay);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { scheduleRebuild(220); });
  window.addEventListener('load', rebuild);
  setTimeout(rebuild, 600);
  if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(function () { scheduleRebuild(60); });
  if ('ResizeObserver' in window) {
    var main = $('MainContent') || doc.body;
    var lastH = 0;
    new ResizeObserver(function () {
      var h = main.offsetHeight;
      if (h !== lastH) { lastH = h; scheduleRebuild(150); }
    }).observe(main);
  }

  /* enlaces a secciones de la portada (/#contacto, /#viajes...): desplazamiento sin recargar */
  doc.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a || a.target === '_blank') return;
    var u;
    try { u = new URL(a.href, window.location.href); } catch (err) { return; }
    if (u.origin !== window.location.origin || u.pathname !== window.location.pathname || !u.hash) return;
    var target = $(decodeURIComponent(u.hash.slice(1)));
    if (!target) return;
    e.preventDefault();
    if (TN.closeMenu) TN.closeMenu();
    target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
    if (window.history && window.history.pushState) window.history.pushState(null, '', u.hash);
  });

  /* ---------------- editor de temas ---------------- */
  doc.addEventListener('shopify:section:reorder', function () { scheduleRebuild(80); });
  doc.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('template[data-hero-pic]')) { heroPick(t); onScroll(); return; }
    if (t.matches('#tripTrack .tp')) {
      /* después del desplazamiento automático del editor */
      setTimeout(function () { scrollToPanel(t); }, 350);
    }
  });

  /* ---------------- init / unload ---------------- */
  function init(scope, isSectionLoad) {
    scope = scope || doc;
    refs();
    initLoader();
    heroPick();
    accentInit(scope);
    bindRows(scope);
    if (isSectionLoad) scheduleRebuild(80); else { measure(); onScroll(); }
  }
  TN.onInit(init);
  TN.onUnload(function (sectionEl) {
    if (!sectionEl) return;
    if (S.preview && sectionEl.contains(S.preview)) {
      pOn = false;
      if (pRAF) cancelAnimationFrame(pRAF);
      pRAF = null;
    }
    if (accIO) homeSections(sectionEl).forEach(function (s) { accIO.unobserve(s); s.__tnAcc = false; });
    scheduleRebuild(80);
  });
})();
